import { General } from "../api/interfaces";
export interface NetworkOptions {
  readonly value: string;
  readonly label: string;
}

export const agreementChannel: Array<General.LabelType> = [
  {
    label: "Retail",
    value: "R",
  },
  {
    label: "Mail",
    value: "M",
  },
  {
    label: "Specialty",
    value: "S",
  },
];

export const lineOfBusiness: Array<General.LabelType> = [
  {
    label: "Cash / Discount",
    value: "cash",
  },
  {
    label: "Commercial",
    value: "commercial",
  },
  {
    label: "Medicaid",
    value: "medicaid",
  },
  {
    label: "Medicare",
    value: "medicare",
  },
  {
    label: "Health Insurance Marketplace (Exchange)",
    value: "exchange",
  },
];

export const networkBenefits: Array<NetworkOptions> = [
  {
    value: "closed_door",
    label: "Closed Door",
  },
  {
    value: "cob_out_of_network",
    label: "COB Out of Network",
  },
  {
    value: "fallback",
    label: "Fallback",
  },
  {
    value: "grace_fill_30",
    label: "Grace Fill 30 Days",
  },
  {
    value: "grace_fill_90",
    label: "Grace Fill 90 Days",
  },
  {
    value: "in_house",
    label: "In-house",
  },
  {
    value: "ltc",
    label: "Long Term Care",
  },
  {
    value: "mail",
    label: "Mail",
  },
  {
    value: "out_of_network",
    label: "Out Of Network",
  },
  {
    value: "preferred",
    label: "Preferred",
  },
  {
    value: "retail",
    label: "Retail",
  },
  {
    value: "retail_30",
    label: "Retail-30",
  },
  {
    value: "retail_90",
    label: "Retail-90",
  },
  {
    value: "specialty",
    label: "Specialty",
  },
  {
    value: "vaccines",
    label: "Vaccines",
  },
];

export const providerAgreementType: Array<General.LabelType> = [
  {
    label: "Closed Door / Hospital",
    value: "closed_door",
  },
  {
    label: "In-house pharmacy",
    value: "in_house",
  },
  {
    label: "Preferred Pharmacy",
    value: "preferred",
  },
  {
    label: "Long-term care",
    value: "ltc",
  },
  {
    label: "Mail",
    value: "mail",
  },
  {
    label: "Retail",
    value: "retail",
  },
  {
    label: "Specialty",
    value: "specialty",
  },
];

export const pricingCompoundOptions = [
  { value: "ingredient_cost_percentage", label: "Ingredient Cost Percentage" },
  { value: "dispensing_fee_percentage", label: "Dispensing Fee Percentage" },
  { value: "ingredient_cost_amount", label: "Ingredient Cost Amount" },
  { value: "dispensing_fee_amount", label: "Dispensing Fee Amount" },
  { value: "price_list_ids", label: "Price List IDs" },
  { value: "price_type_selection", label: "Price Type Selection" },
  { value: "selected_price_types", label: "Selected Price Types" },
  { value: "awp_brand_discount", label: "AWP Brand Discount" },
  { value: "awp_generic_discount", label: "AWP Generic Discount" },
  { value: "awp_brand_dispensing_fee", label: "AWP Brand Dispensing Fee" },
  { value: "awp_generic_dispensing_fee", label: "AWP Generic Dispensing Fee" },
  { value: "nadac_brand_discount", label: "NADAC Brand Discount" },
  { value: "nadac_generic_discount", label: "NADAC Generic Discount" },
  { value: "nadac_brand_dispensing_fee", label: "NADAC Brand Dispensing Fee" },
  { value: "nadac_generic_dispensing_fee", label: "NADAC Generic Dispensing Fee" },
  { value: "wac_brand_discount", label: "WAC Brand Discount" },
  { value: "wac_generic_discount", label: "WAC Generic Discount" },
  { value: "wac_brand_dispensing_fee", label: "WAC Brand Dispensing Fee" },
  { value: "wac_generic_dispensing_fee", label: "WAC Generic Dispensing Fee" },
  { value: "specialty_list_brand_discount", label: "Specialty List Brand Discount" },
  { value: "specialty_list_generic_discount", label: "Specialty List Generic Discount" },
  { value: "specialty_list_brand_dispensing_fee", label: "Specialty List Brand Dispensing Fee" },
  { value: "specialty_list_generic_dispensing_fee", label: "Specialty List Generic Dispensing Fee" },
  { value: "specialty_list_brand_delta_rate", label: "Specialty List Brand Delta Rate" },
  { value: "specialty_list_generic_delta_rate", label: "Specialty List Generic Delta Rate" },
  { value: "specialty_list_brand_delta_dispensing_fee", label: "Specialty List Brand Delta Dispensing Fee" },
  { value: "specialty_list_generic_delta_dispensing_fee", label: "Specialty List Generic Delta Dispensing Fee" },
  { value: "u_and_c_brand_dispensing_fee", label: "U&C Brand Dispensing Fee" },
  { value: "u_and_c_generic_dispensing_fee", label: "U&C Generic Dispensing Fee" },
  { value: "mac_list_brand_discount", label: "MAC List Brand Discount" },
  { value: "mac_list_generic_discount", label: "MAC List Generic Discount" },
  { value: "mac_list_brand_dispensing_fee", label: "MAC List Brand Dispensing Fee" },
  { value: "mac_list_generic_dispensing_fee", label: "MAC List Generic Dispensing Fee" },
  { value: "mac_list_unit_price_adjustment", label: "MAC List Unit Price Adjustment" },
  { value: "submitted_pricing", label: "Submitted Pricing" },
];


export const pricingCompoundOptionTypes = {
  ingredient_cost_percentage: "%",
  dispensing_fee_percentage: "%",
  ingredient_cost_amount: "$",
  dispensing_fee_amount: "$",
  price_list_ids: "string",
  price_type_selection: "lesser_of_first_of",
  selected_price_types: "selected_price_types",
  awp_brand_discount: "%",
  awp_generic_discount: "%",
  awp_brand_dispensing_fee: "$",
  awp_generic_dispensing_fee: "$",
  nadac_brand_discount: "%",
  nadac_generic_discount: "%",
  nadac_brand_dispensing_fee: "$",
  nadac_generic_dispensing_fee: "$",
  wac_brand_discount: "%",
  wac_generic_discount: "%",
  wac_brand_dispensing_fee: "$",
  wac_generic_dispensing_fee: "$",
  specialty_list_brand_discount: "%",
  specialty_list_generic_discount: "%",
  specialty_list_brand_dispensing_fee: "$",
  specialty_list_generic_dispensing_fee: "$",
  specialty_list_brand_delta_rate: "%",
  specialty_list_generic_delta_rate: "%",
  specialty_list_brand_delta_dispensing_fee: "$",
  specialty_list_generic_delta_dispensing_fee: "$",
  u_and_c_brand_dispensing_fee: "$",
  u_and_c_generic_dispensing_fee: "$",
  mac_list_brand_discount: "%",
  mac_list_generic_discount: "%",
  mac_list_brand_dispensing_fee: "$",
  mac_list_generic_dispensing_fee: "$",
  mac_list_unit_price_adjustment: "%",
  submitted_pricing: "input",
};

